import * as React from 'react'

const ImgRejectedUri = require('./imgs/rejected.png').default
const ImgEncoursUri = require('./imgs/encours.png').default

type Props = {
  status?: BusinessDeclarationPicture['status']
} & React.ImgHTMLAttributes<HTMLImageElement>

/**
 *
 * Sais pas si c'est une bonne idee mais je suppirme l click en cas d'erreur.
 * Comme ça on ne pourra pas "zoomer" sur le simages qui ne sont pas prêtes.
 */

const Image = ({ src, status, onClick, ...rest }: Props) => {
  const [currentUrl, setCurrentUrl] = React.useState(() => src)

  return (
    <img
      src={currentUrl}
      onError={() => {
        if (status) {
          if (status === 'PENDING') {
            setCurrentUrl(ImgEncoursUri)
          } else if (status === 'REJECTED') {
            setCurrentUrl(ImgRejectedUri)
          }
        }
      }}
      onClick={onClick}
      {...rest}
    />
  )
}

export default Image
